<div *ngIf='(vm$ | async) as vm'>
  <app-page-header [vm]="vm" title='Chauffeur Portal' [canGoBack]="true" [canRefresh]="true"
    (refreshClick)="refreshPage()">
  </app-page-header>

  <div *ngIf="vm.workingText">
    <span>{{vm.workingText}}</span>
  </div>
  <div *ngIf="vm.errorText">
    <h1 class="text-danger">{{vm.errorText}}</h1>
  </div>
</div>